import { Box, Button, IconButton, Switch } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { RlFlToggleStateEnum } from '../../../store/maps/reducer';
import appTheme from '../../common/theme/appTheme.json';
import { ThemeInterface } from '../theme/AppThemeInterface';
import { MapActionsContext } from './BaseMapContainer';
const useStyles = makeStyles(theme =>
  createStyles({
    toggleItemButton: {
      textTransform: 'capitalize',
      fontSize: '12px',
      letterSpacing: '0px',
    },
    closeIcon: {
      color: '#ffffff',
    },
    track: {
      backgroundColor: '#9fafbc',
    },
  }),
);

interface RlFlToggleSwitchProps {
  rlFlToggleState: RlFlToggleStateEnum;
}

const RlFlToggleSwitch = ({ rlFlToggleState }: RlFlToggleSwitchProps) => {
  const theme: ThemeInterface = appTheme;

  const classes = useStyles();
  const dispatch = useDispatch();

  const mapActionsContext = useContext(MapActionsContext);

  const { switchToFlContours, switchToRlContours, disableHeatMaps } = mapActionsContext.mapActions;

  const onChange = useCallback(() => {
    if (rlFlToggleState === RlFlToggleStateEnum.ReturnLink) {
      dispatch(switchToFlContours());
    } else {
      dispatch(switchToRlContours());
    }
  }, [rlFlToggleState, switchToFlContours, switchToRlContours, dispatch]);

  return (
    <Box minWidth="234px" height="28px" bgcolor={theme.primaryBackgroundColor} display="flex" alignItems="center">
      <Box ml="0px">
        <Button
          className={classes.toggleItemButton}
          onClick={() => {
            dispatch(switchToFlContours());
          }}
        >
          <Box
            color={
              rlFlToggleState === RlFlToggleStateEnum.ForwardLink ? theme.buttonSelectedColor : theme.primaryTextColor
            }
            sx={{
              '@media print': {
                fontSize: '10px',
              },
            }}
          >
            Forward Link
          </Box>
        </Button>
      </Box>
      <Switch
        color="default"
        size="small"
        classes={{ track: classes.track }}
        checked={rlFlToggleState === RlFlToggleStateEnum.ReturnLink}
        onChange={onChange}
        name="RL RL Toggle"
      />
      <Box>
        <Button
          className={classes.toggleItemButton}
          onClick={() => {
            dispatch(switchToRlContours());
          }}
        >
          <Box
            color={
              rlFlToggleState === RlFlToggleStateEnum.ReturnLink ? theme.buttonSelectedColor : theme.primaryTextColor
            }
            sx={{
              '@media print': {
                fontSize: '10px',
              },
            }}
          >
            Return Link
          </Box>
        </Button>
      </Box>
      <Box>
        <Box height="28px" width="1px" bgcolor={'#808080'} />
      </Box>
      <Box>
        <IconButton
          size="small"
          onClick={() => {
            dispatch(disableHeatMaps());
          }}
        >
          <CloseRoundedIcon fontSize="small" className={classes.closeIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default RlFlToggleSwitch;
